import { Injectable } from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class FirestoreService implements Resolve<any> {

  constructor(
    private httpClient: HttpClient,
  ) {

  }

  getSiteText(field: string): Observable<string> {
    return this.httpClient.get(`${environment.apiUrl}/site-text/${field}`, {responseType: 'text', headers: {'Accept': 'text/html'}})
  }

  getSiteNav(field: string): Observable<any> {
    return this.httpClient.get(`${environment.apiUrl}/site-text/${field}`, {responseType: 'json', headers: {'Accept': 'application/json'}})
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    const id = route.paramMap.get('id');
    return this.httpClient.get(`${environment.apiUrl}/events/${id}`);
  }
}
